export default __webpack_public_path__ + "roboto-v20-latin-regular.eot";